export default {
  ERROR: 'ERROR',
  WARN: 'WARN',
  SUCCESS: 'SUCCESS',
  LOADING: 'LOADING',
}



// WEBPACK FOOTER //
// ./src/const/MessageTypes.js